export default "__VITE_ASSET__DhEcmikn__"